
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import VisitsCategoriesForm from "@/form/Settings/categories/visits";
import { VisitsCategoriesSettingsStore } from  "@/store/modules/VisitsCategoriesSettings";
import { IVisitCategoriesListItem } from '@/entity/visits/visitCategories.types';
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import VisitsCategoriesUpdateForm from "@/form/Settings/categories/visitsUpdate";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class Visits extends Vue {
    formReady: boolean = false
    form = new VisitsCategoriesForm();
    updateForm = new VisitsCategoriesUpdateForm();
    modal_form: boolean = false;
    update_modal_form: boolean = false;
    checkRole: boolean = false;

    showUpdateForm(visit : IVisitCategoriesListItem){
        this.updateForm = new VisitsCategoriesUpdateForm();
        this.updateForm.setFormData(visit);
        this.update_modal_form = true;
        console.log(this.updateForm);
    }

    async updateVisit(): Promise<void> {
        if (await this.updateForm.submit(VisitsCategoriesSettingsStore.update)) {
            this.update_modal_form = false;
            await VisitsCategoriesSettingsStore.fetchAll();
        }
    }

    async saveCategory(): Promise<void> {
        if (await this.form.submit(VisitsCategoriesSettingsStore.create)) {
            this.modal_form = false;
            await VisitsCategoriesSettingsStore.fetchAll();
        }
    }

    get visitCategories(): any{ return VisitsCategoriesSettingsStore.visitCategories }

    async created(): Promise<void> {
        try {
            this.formReady = false
            this.checkRole = Vue.auth.check('owner');
            let filter = {
                limit: 20,
                filter: {}
            };
            if(!this.checkRole) {
                filter.filter = {}
            }
            await VisitsCategoriesSettingsStore.fetchAll(filter);
        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true
        }
    }
}
